import React from "react";
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate, NavigateFunction } from 'react-router-dom';
import { createTheme, CssBaseline, Divider, Grid, PaletteType, ThemeProvider } from "@material-ui/core";
import SwaAppBar from "./components/AppBar";
import useStyles from "./components/Styles";
import { useStore } from "./redux/Store";
import MainContent from "./components/content/MainContent";
import { Toaster } from 'react-hot-toast';
import Callback from "./components/callback";
import { IftUser } from "./auth/user";
import {useSessionStorage} from "usehooks-ts";
import LoginPage from "./components/LoginPage";
import { startAuthenticationFlow, finishAuthenticationFlow } from "./auth/authentication";
import env from './auth/environment'

function App() {
  const [user, setUser] = useSessionStorage<null | IftUser>('ift.user', null);
  const classes = useStyles();
  const store = useStore();
  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          type: store.state.theme as PaletteType,
        },
      }),
    [store.state.theme],
  );


  const handleLogin = async (user: IftUser, navigate: NavigateFunction) => {
    setUser(user)
    navigate('/');
  };

  // const handleLogin2 = () => {
  //   const sampleUser = {
  //     userName: "x305240",
  //     groups: ["IF_training_admin_S"],
  //     accessToken: "eyJhbGciOiJSUzI1NiIsImtpZCI6InFMLXZwN3p2bGJhdDA4akxKcGoxSDhlZ2dfayIsInBpLmF0bSI6InRtYTUifQ.eyJzY29wZSI6Im9wZW5pZCBlbWFpbCBwcm9maWxlIiwiY2xpZW50X2lkIjoicDUwMjA4MSIsImlzcyI6Imh0dHBzOi8vc3NvLmZlZC5kZXYuYXdzLnN3YWNvcnAuY29tIiwianRpIjoiVE5ZYVBubUc0cUpISG9aQlVUSlhNTDFnRG81REw1ZVQiLCJhdWQiOiJhdWQ6Ly9zc28uZmVkLmRldi5hd3Muc3dhY29ycC5jb20vaW5mbGlnaHR0cmFpbmluZ2NvbXBsaWFuY2UvcDUwMjA4MSIsInN1YiI6IngzMDUyNDAiLCJjb20uc3dhY29ycC5hdXRoLmFjY2Vzc3Rva2VuLnZlcnNpb24iOiIxLjAuMCIsIm5iZiI6MTY5MTU5Mzk4MiwiaXRvIjoxNSwiYXV0aF90aW1lIjoxNjkxNTkzOTgyLCJncm91cHMiOiJJRl90cmFpbmluZ19hZG1pbl9TIiwiY24iOiJ4MzA1MjQwIiwiaWF0IjoxNjkxNTkzOTgyLCJleHAiOjE2OTE2MDExODJ9.i4oYFYPXBv_EnaK5njCKqqdSnrvhK-lykkfTnT38PH5S66KuQWZEZnGO4mQQrDqrc9pzDqJI74Uxzx1qo3Z8O4YFafFoqtJLs7sACHxarGQTzuifLmxWDO3W42xZa3kT30mihlIj_kWLkjGNfrsTY1X1ddVX6-6a_8yG8xuMim6Zc0IpRpMipYqnQ-E9jwwAqY86sSacFspflU4WGBM7PK8FkHfmR3jNYMC7YBXp0A2edUCfANtazNwoeas5GJMrPhvbxm9MeI9m-sCi8JpdMc6dk9gzqjjRVb7kO_-mR5u0FA9W5DxQ5fi5uiUHEvq5NcdEkYdldPV-TyXu6YM5hw",
  //     exp: 1691601182
  //   }
  //   setUser(sampleUser)
  // }

  return (
    <div className={classes.root}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SwaAppBar />
        <main className={classes.content} id="main-app-area">
          <div className={classes.appBarSpacer} />
          <Grid container direction="column" justifyContent="center" alignItems="center">
            <Grid>
            <div><Toaster/></div>
            {!user &&
              <Router>
                  <Routes>
                      <Route path="/" element={<LoginPage startAuthenticationFlow={startAuthenticationFlow}/>}/>
                      <Route path="/callback.html" element={
                          <Callback handleLogin={handleLogin} finishAuthenticationFlow={finishAuthenticationFlow}/>}
                      />
                  </Routes>
              </Router>
            }
            {user && user.accessToken && user?.groups.includes(env.pingGroup) &&
              <Router>
                <Routes>
                  <Route path="/"  element={<MainContent />}/>
                  <Route path='*' element={<Navigate to='/' />} />
                </Routes>
              </Router>
            }
            </Grid>
          </Grid>
        </main>
        <Divider />
      </ThemeProvider>
    </div>
  );
}

export default App;
